import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getSPDataWithParams } from 'src/supportPortal/services/services'

export const NON_CLINICAL_LOCATION = {
  id: 'non-clinical',
  slug: 'non-clinical',
  title: 'Non Clinical',
}

export async function getMinimalClinicLocationData(slug) {
  const sessionTherString = sessionStorage.getItem('supportClinicData')
  const clinicLocationData = JSON.parse(sessionTherString)
  if (clinicLocationData && clinicLocationData?.slug === slug) {
    return clinicLocationData
  }

  if (slug === 'non-clinical') {
    sessionStorage.setItem('supportClinicData', JSON.stringify(NON_CLINICAL_LOCATION))
    return NON_CLINICAL_LOCATION
  }

  const resp = await getSPDataWithParams('/api/secure/cc/support/clinic/by-slug', {
    'clinic-slug': slug,
  })
  console.log({ resp })
  if (resp && isCommonResponseSuccessfulV2(resp)) {
    const dat = getDataMapFromCommonResponse(resp)?.clinic

    console.log({ dat })
    sessionStorage.setItem('supportClinicData', JSON.stringify(dat))

    return dat
  }
  return clinicLocationData
}
